export interface IUsersReferenceStepOneProps {
  users: any[]
  usersLoader: any
  filterValues: any
  modifySelectedUser: (user: {}) => {}
  usersRequest: () => {}
  resetState: () => {}
  goBack: () => {}
}

export const TypeFilter = {
  idFilter: 'id',
  identitySystemIdFilter: 'identitySystemId',
  codeFilter: 'code',
  nameFilter: 'name',
  surnameFilter: 'surname',
  organizationalUnitFilter: 'organizational_unit',
  managerFullNameFilter: 'resp_full_name',
  typeFilter: 'type',
  emailFilter: 'email',
  netsIdFilter: 'netsId',
  netsOrgunitIdFilter: 'netsOrgunitId',
  netsPersonIdFilter: 'netsPersonId',
}

export const USER_REFERENCE_FORM_FILTER: string = 'UserReferencesFormFilter'

export const mockUsers: any[] = [
  {
    id: 1,
    name: 'Mario',
    surname: 'Rossi',
    userId: 'CO02560',
    user_typlogy: 'Consultant',
    responsible: 'Luca Bianchi',
    society: 'Assist Digital',
    operative_unit: 'Ufficio 1',
  },
  {
    id: 2,
    name: 'Luca',
    surname: 'Bianchi',
    userId: 'CO11111',
    user_typlogy: 'PMO',
    responsible: 'Mattia Verdi',
    society: 'Assist Digital',
    operative_unit: 'Ufficio 2',
  },
  {
    id: 3,
    name: 'Mattia',
    surname: 'Verdi',
    userId: 'CO12345',
    user_typlogy: 'CEO',
    responsible: 'None',
    society: 'Holding',
    operative_unit: 'Ufficio 3',
  },
]
